import React from "react";

const partnersData = [
  { img: "img/partners/01.jpg", name: "Ultratech Cement" },
  { img: "img/partners/02.jpg", name: "Ambuja Cement" },
  { img: "img/partners/03.webp", name: "Shree Cement" },
  { img: "img/partners/04.jpg", name: "Acc Cement" },
  { img: "img/partners/05.png", name: "JK Super Cement" },
  { img: "img/partners/06.png", name: "JSW Cement" }
];

export const Partners = () => {
  return (
    <section id="partners" className="text-center py-5" style={{paddingTop:'6rem'}}>
      <div className="container">
        {/* Section Title */}
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-titles">
              <h2>Our Partners</h2>
              <p>
                We take pride in collaborating with industry-leading partners who share our commitment to excellence.
                Together, we deliver high-quality construction solutions, ensuring innovation, reliability, and lasting value in every project.
              </p>
            </div>
          </div>
        </div>

        {/* Partners Grid */}
        <div className="row g-4">
          {partnersData.map((d, i) => (
            <div key={`${d.name}-${i}`} className="col-12 col-sm-6 col-md-4">
              <div className="card shadow-lg border-0">
                <img src={d.img} alt={d.name} className="card-img-top img-fluid" />
                <div className="card-body">
                  <h5 className="card-title">{d.name}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
